const source = 'podsDataTable'

function getSwitchInMethod () {
  const keys = Object.keys(this.filtered.items).filter((s) => s == source)
  if(keys.length > 0){
    const ids = this.filtered.items[source]

    this.$eventBus.emit('show-dialog-page', {
      page: 'pods-switch-in',
      title: 'Switch-In',
      data: ids,
      maximize: false,

      buttonOk: {
        label: 'Esegui',
        icon: 'pi pi-check',
        class: '',
        visible: true,
        disabled: false,
      },

      buttonCancel: {
        label: 'Annulla',
        icon: 'pi pi-times',
        class: 'p-button-text',
        visible: true,
        disabled: false,
      },
    })
  } 
}

export default {
  'bindTo': 'this',
  'method': getSwitchInMethod,
}
